import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-402ea361"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chats-preview-container" }

import { GetterTypes, MutationTypes } from "@/store";
import { Chat, ChatState } from "@/store/chats/types";
import { LayoutTypes } from "@/store/app/state";
import { useComputedValue, useInfiniteScroll } from "@/composables";
import ChatPreview from "./ChatPreview.vue";
import ChatPreviewNew from "./ChatPreviewNew.vue";
import ChatsPreviewLoadingContainer from "./ChatsPreviewLoadingContainer.vue";
import { useRoute } from "vue-router";
import { computed } from "vue";
import { useStore } from "vuex";
import {
  getChatOnSnapshotListenersObject,
  getFirebaseChatDataAsync,
  getIsChatPreviewVisible,
} from "@/utils/chat";
import { getRawMessagesDetails } from "@/utils/message";
import { IChatModifiedReferenceObject } from "@/types/chat";
import { InfiniteScrollDirection } from "@/types/app";
import MobileInstallationBanner from "@/components/banner/MobileInstallationBanner/MobileInstallationBanner.vue";
import { convertRawChat } from "@/utils/chat/convertRawChat";
import { ChatsState } from "@/store/chats/state";
import { getDifferenceArray } from "@/utils/modifiers/getDifferenceArray";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatsPreviewContainer',
  setup(__props) {

const route = useRoute();
const chats = useComputedValue<Chat[]>(
  GetterTypes.GET_CONVERTED_CHATS_ARRAY_FILTERED,
);
const chatsState = useComputedValue<ChatsState>(GetterTypes.GET_CHATS_STATE);
const initialLoad = useComputedValue<boolean>(
  GetterTypes.GET_CHATS_INITIAL_LOAD,
);
const layoutType = useComputedValue(GetterTypes.GET_LAYOUT_TYPE);
const allChatsCount = computed(() => {
  const { allChatIds } = chatsState.value;

  return allChatIds.length;
});
const isNewChat = computed<boolean>(() => route.path === "/new");
const { getters, commit } = useStore();
const lastChat = computed(() => {
  if (!chats.value.length) {
    return;
  }
  const lastChatId = chats.value[chats.value.length - 1].id;
  const chatState: ChatState = getters[GetterTypes.GET_CHAT](lastChatId);
  return chatState;
});
const visibleChats = computed(() =>
  chats.value.filter(getIsChatPreviewVisible),
);

const handleLoadMoreChats = async () => {
  if (!lastChat.value || !initialLoad.value) {
    return;
  }
  const { remainingChatIds, chatIds } = chatsState.value;
  if (allChatsCount.value <= chats.value.length) {
    data.canLoadMore = false;
    return;
  }

  try {
    const chats = await getFirebaseChatDataAsync({
      chatIds: getDifferenceArray(remainingChatIds, chatIds),
    });

    const modifiedChats: IChatModifiedReferenceObject[] = chats.map(
      (rawChat) => {
        const { rawMessages, ...rawMessagesObj } =
          getRawMessagesDetails(rawChat);
        const chatListenersObject = getChatOnSnapshotListenersObject(
          chats.map((chat) => chat.id),
        );
        return {
          ...rawMessagesObj,
          rawChat,
          chatId: rawChat.id,
          isVisible: Boolean(rawChat && rawChat.lastMessage),
          convertedChat: convertRawChat(rawChat),
          chatUnsubscribe: chatListenersObject[rawChat.id].unsubcribe,
        };
      },
    );

    if (modifiedChats.length === 0) {
      data.canLoadMore = false;
      return;
    }
    commit(MutationTypes.APPEND_CHATS, modifiedChats);
  } catch (error) {
    throw error;
  }
};

const { scrollContainerRef, sentinelRef, data } = useInfiniteScroll(
  handleLoadMoreChats,
  InfiniteScrollDirection.Down,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "scrollContainerRef",
      ref: scrollContainerRef,
      class: "messages-wrapper"
    }, [
      (isNewChat.value && _unref(layoutType) === _unref(LayoutTypes).DESKTOP)
        ? (_openBlock(), _createBlock(ChatPreviewNew, { key: 0 }))
        : _createCommentVNode("", true),
      (!_unref(initialLoad))
        ? (_openBlock(), _createBlock(ChatsPreviewLoadingContainer, { key: 1 }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleChats.value.slice(0, 3), (chat, index) => {
        return (_openBlock(), _createBlock(ChatPreview, {
          key: chat.id,
          index: index,
          chat: chat
        }, null, 8, ["index", "chat"]))
      }), 128)),
      _createVNode(MobileInstallationBanner),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleChats.value.slice(3), (chat) => {
        return (_openBlock(), _createBlock(ChatPreview, {
          key: chat.id,
          chat: chat
        }, null, 8, ["chat"]))
      }), 128)),
      (_unref(data).isLoadingMore)
        ? (_openBlock(), _createBlock(ChatsPreviewLoadingContainer, { key: 2 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        ref_key: "sentinelRef",
        ref: sentinelRef
      }, null, 512)
    ], 512)
  ]))
}
}

})